import { loginRedirect, loginNoRedirect } from './login';
import { API_PATH, SignalR } from 'constants/alo';

const HOST = window.location.protocol + '//' + window.location.host;

export const API = HOST + `${API_PATH}`;

export const x = "02200540-9BA3-4A54-B797-486DFC991845";

/**
 * Creates query string from object 
 */
export const queryString = (obj) => {
    if (!obj || !Object.keys(obj).length) {
        return;
    }

    let result = '';

    for (let key in obj) {
        const value = obj[key] instanceof Date ? (obj[key] as Date).toISOString() : obj[key];

        if (value !== null && value !== undefined) {
            if (result.length) {
                result = result + `&${key}=` + value;
            } else {
                result = `?${key}=` + value;
            }
        }
    }

    return result;
}

export const HttpMethod = {
    Get: 'GET',
    Post: 'POST',
    Delete: 'DELETE',
    Put: 'PUT'
};

export function formatEndpoint(url: string, root: string = null): string {
    url = url.startsWith('/') ? url : `/${url}`;
    root = root || API;
    const result = `${root}${url}`.replace(/^.*\/\/[^\/]+/, '').toLowerCase().split("?")[0];
    return result;
}

export async function generateHmacSignature(endpoint: string, timestamp: string, secretKey: string) {
    // Combine the endpoint and timestamp into a single string
    const data = endpoint + "|" + timestamp;

    // Convert the data and key into ArrayBuffer
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data); // Data as Uint8Array
    const keyBuffer = encoder.encode(secretKey); // Secret key as Uint8Array

    // Import the secret key as a crypto key
    const key = await crypto.subtle.importKey(
        "raw", // Import the key as raw binary data
        keyBuffer, // The raw secret key as an ArrayBuffer
        { name: "HMAC", hash: { name: "SHA-256" } }, // Use SHA-256 for HMAC
        false, // The key is not extractable
        ["sign"] // The key can only be used for signing (HMAC)
    );

    // Compute the HMAC of the data
    const signatureBuffer = await crypto.subtle.sign("HMAC", key, dataBuffer);

    // Convert the signature to a Base64 string (to send it in the header)
    const signatureArray = new Uint8Array(signatureBuffer);
    
    const bytes = [];

    signatureArray.forEach(e => {
        bytes.push(e);
    });

    const signatureBase64 = btoa(String.fromCharCode(...bytes));

    return signatureBase64;
}

export const getRequestInit = async (endpoint: string, method: string, data?: any): Promise<RequestInit> => {
    const init: RequestInit = {
        credentials: 'include',
        method
    };

    const timestamp = new Date().toISOString();
    const secret = await generateHmacSignature(endpoint, timestamp, x);

    init.headers = {
        'X-Liftiq-Signature': secret,
        'X-Liftiq-Timestamp': timestamp
    };
    
    if (data) {
        if (data instanceof FormData) {
            init.body = data;
        } else {
            init.headers['Accept'] = 'application/json';
            init.headers['Content-Type'] = 'application/json';
            init.body = JSON.stringify(data);
        }
    }

    return init;
};

export const get = async <T>(url: string, parameters: any = null, root: string = API, abort?: (controller: AbortController) => void): Promise<IJsonResult<T>> => {

    var endpoint = formatEndpoint(url, root);

    root = root || API;

    let qs = '';

    if (parameters !== null && parameters !== undefined) {
        qs = queryString(parameters);
    }

    url = `${root}/${url}${qs}`;

    const init: RequestInit = await getRequestInit(endpoint, HttpMethod.Get, null);

    if (abort) {
        const controller = new AbortController()
        const signal = controller.signal;

        init.signal = signal;

        abort(controller);
    }

    return window.fetch(url, init).then((response) => {
        if (response.status === 403 || response.status === 401) {
            window.location.href = '/app/lm/login';
            return;
        }
        return response.json();
    }).then(result => {
        if (result.ExceptionMessage) {
            throw new Error(result.ExceptionMessage);
        }
        return toJsonResult(result);    
    }).catch((err: Error) => {
        return {
            success: false,
            errors: [err.message],
            data: null
        }
    });
    
};

export const get2 = async <T>(url: string, options?: GetOptions): Promise<IJsonResult<T>> => {

    var endpoint = formatEndpoint(url);

    const init: RequestInit = await getRequestInit(endpoint, HttpMethod.Get, null);

    options = options || {} as GetOptions;

    if (options.abort) {
        const controller = new AbortController()
        const signal = controller.signal;

        init.signal = signal;

        options.abort(controller);
    }

    let qs = '';

    if (options.parameters !== undefined && options.parameters !== null) {
        qs = queryString(options.parameters);
    }

    let root = options.root || API;

    return window.fetch(`${root}/${url}${qs}`, init).then((response) => {
        if (response.status === 403 || response.status === 401) {
            window.location.href = '/app/lm/login';
            return;
        }
        return response.json();
    }).then(result => {
        return toJsonResult(result);
    }).catch((err) => {

    });

};

export const del = async <T>(url, data?: any): Promise<IJsonResult<T>> => {
    var endpoint = formatEndpoint(url);
    const init: RequestInit = await getRequestInit(endpoint, HttpMethod.Delete, data);

    return window.fetch(`${API}/${url}`, init).then((response) => {
        if (response.status === 403 || response.status === 401) {
            console.log('User is unauthorized. Redirecting to login...');
            window.location.href = '/app/lm/login';
            return;
        }
        return response.text().then(text => {
            return text ? JSON.parse(text) : true;
        });
    }).then(result => {
        return toJsonResult(result);
    }).catch((err) => {
        
    });
};

export const post = async <T>(url, data?: any, root: string = API): Promise<IJsonResult<T>> => {
    var endpoint = formatEndpoint(url);
    const init: RequestInit = await getRequestInit(endpoint, HttpMethod.Post, data);

    return window.fetch(`${root}/${url}`, init).then((response) => {

        if (response.status === 403 || response.status === 401) {
            window.location.href = '/app/lm/login';
            return;
        }

        if (response.status === 500) {
            return response.text().then(text => {

                if (text) {
                    const err = JSON.parse(text);
                    return {
                        success: false,
                        data: null,
                        errors: [err.ExceptionMessage]
                    }
                }
            });
        }

        return response.text().then(text => {
            return text ? JSON.parse(text) : true;
        });

    }).then(result => {
        return toJsonResult(result);
    }).catch((err) => {
        console.error('POST error:', err);
    });
};


export const post2 = async <T>(url, options?: PostOptions): Promise<IJsonResult<T>> => {
    var endpoint = formatEndpoint(url);
    const init: RequestInit = await getRequestInit(endpoint, HttpMethod.Post, options.data);

    if (options.abort) {
        const controller = new AbortController()
        const signal = controller.signal;

        init.signal = signal;

        options.abort(controller);
    }
    
    const root = options.root || API;

    return window.fetch(`${root}/${url}`, init).then((response) => {
        if (response.status === 403 || response.status === 401) {
            window.location.href = '/app/lm/login';
            return;
        }
        return response.text().then(text => {
            return text ? JSON.parse(text) : true;
        });
    }).then(result => {
        return toJsonResult(result);
    }).catch((err) => {
        
    });

};

export const put = async <T>(url, data: any): Promise<IJsonResult<T>> => {
    var endpoint = formatEndpoint(url);
    const init: RequestInit = await getRequestInit(endpoint, HttpMethod.Put, data);

    return window.fetch(`${API}/${url}`, init).then((response) => {
        if (response.status === 403 || response.status === 401) {
            window.location.href = '/app/lm/login';
            return;
        }
        return response.text().then(text => {
            return text ? JSON.parse(text) : true;
        });
    }).then(result => {
        return toJsonResult(result);
    }).catch((err) => {
        console.error('PUT error:', err);
    });
};

export function getParameterByName(name: string, url?: string) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getCookie(cname: string) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

export function deleteCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export async function logout(withRedirect: boolean = true) {
    await withRedirect ? loginRedirect() : loginNoRedirect();
}

const toJsonResult = (result: any) => {
    if (result && result.success === undefined && result.data === undefined && result.errors === undefined) {
        return {
            success: true,
            data: result,
            errors: []
        }
    }

    return result;
}